import { MilestonesView } from '@/components/gamification/MilestonesView';
import { TripErrorBoundary } from '@/utils/errorBoundary';

export default function MilestonesRoute() {
  return (
    <TripErrorBoundary name="GamificationMilestones">
      <MilestonesView />
    </TripErrorBoundary>
  );
}
